export default function FNum(num, round = true) {
  if (round === false) {
    // console.log(
    //   `num >> ${num}`,
    //   `FNum >> ${parseFloat(num).toFixed(2).toLocaleString()}`
    // );
    return parseFloat(num).toFixed(2).toLocaleString();
  }
  // console.log(
  //   `num >> ${num}`,
  //   `Round FNum >> ${Math.round(num).toLocaleString()}`
  // );
  return Math.round(num).toLocaleString();
}
